<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container  fixed-top">
            <header class="header  navbar navbar-expand-sm">
                <div class="container">
                    <ul class="navbar-item theme-brand flex-row text-center">
                        <li class="nav-item theme-logo">
                            <router-link to="/agra">
                                <img src="@/assets/images/navbar/headlogo.svg" class="navbar-logo" alt="logo" />
                            </router-link>
                        </li>
                    </ul>
                    <div class="navbar-item flex-row ms-md-auto">
                        <div class="dropdown nav-item user-profile-dropdown btn-group mx-1 hoverUp hovLg" v-show="isMember">
                            <button type="button" class="btn dropdown-toggle btn-icon-only user nav-link" @click="showProfileModal">
                                <img src="../../assets/images/navbar/profileIcon.png" class="rounded-circle">
                            </button>
                        </div>

                        <!-- <div class="dropdown nav-item user-profile-dropdown btn-group mx-1 hoverUp hovLg" v-show="!isMember">
                            <a href="javascript:;" class="btn dropdown-toggle btn-icon-only user nav-link" @click="showLoginModal">
                                <img src="../../assets/images/navbar/profileIconlogin.png" class="rounded-circle">
                            </a>
                        </div> -->

                        <div class="dropdown nav-item user-profile-dropdown btn-group mx-1 hoverUp hovLg" v-if="isLoggin">
                            <a href="javascript:;" id="ddmenu" data-bs-toggle="dropdown" aria-expanded="false"
                                class="btn dropdown-toggle btn-icon-only user nav-link">
                                <img src="../../assets/images/navbar/hamburger.svg">
                            </a>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddmenu">
                                <li role="presentation">
                                    <router-link to="/agra/mysurvey" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> แบบสำรวจ
                                    </router-link>
                                </li>

                                <li role="presentation" v-if="memberData.role === 'admin'">
                                    <router-link to="/agra/admin/survey" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> แบบสำรวจ (ผู้ดูแลระบบ) 
                                    </router-link>
                                </li>
                                <li role="presentation" v-if="memberData.role === 'admin'">
                                    <router-link to="/agra/admin/organizemanagement" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> จัดการหน่วยงาน
                                    </router-link>
                                </li>
                                <li role="presentation" v-if="memberData.role === 'admin'">
                                    <router-link to="/agra/admin/usermanagement" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> จัดการผู้ใช้งาน
                                    </router-link>
                                </li>

                                <!-- <li role="presentation">
                                    <router-link to="/learning" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> แบบสำรวจ(ผู้ดูแลระบบ) 
                                    </router-link>
                                </li>

                                <li role="presentation">
                                    <router-link to="/reportercommunity" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> จัดการวิทยาศาสตร์พลเมือง
                                    </router-link>
                                </li>

                                <li role="presentation">
                                    <router-link to="/reportercommunity" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> จัดการวีดีโออบรม
                                    </router-link>
                                </li>

                                <li role="presentation">
                                    <router-link to="/reportercommunity" class="dropdown-item">
                                        <font-awesome-icon :icon="['far', 'circle']" /> ปฏิทินกิจกรรม
                                    </router-link>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
        </div>
        <!--  END NAVBAR  -->
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import eventBus from '@/eventBus/eventBus.js';
    import Utils from '@/plugins/datepickerHelper.js';

    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    // const memberData = ref(store.getters['auth/getMember']);
    const callApi = (param) => store.dispatch('api/apiCall', param);
    const isLoggin = ref(store.getters['auth/getLoginState']);

    const memberData = ref({
        _id: null,
        username: null,
        picture: null,
        role: 'member'
    });

    const isMember = ref(false);

    function setProfileData() {
        let member = JSON.parse(localStorage.getItem('member'));
        if (member) {
            // getNewAlert();
            isMember.value = true;
            // memberData.value._id = member._id;
            // memberData.value.username = member.userName;
            memberData.value._id = member.member_id;
            memberData.value.member_displayname = member.member_displayname;
            memberData.value.role = member.role;
            memberData.value.picture = (member.member_img_profile)?member.member_img_profile:'/image/anonymous_1.png';
        }
    }

    const toggleMode = (mode) => {
        let currentTheme = 'light';
        if (mode) {
            currentTheme = mode;
            localStorage.setItem('mode', currentTheme);
            window.$appSetting.toggleMode(currentTheme);
        } else {
            currentTheme = (localStorage.getItem('mode')) ? localStorage.getItem('mode') : 'light'
        }

        window.$appSetting.toggleMode(currentTheme);
    };
    
    function showLoginModal () {
        eventBus.emit('showLoginModal');
    }

    const alertWarningMsg = (txt) => {
        try {
        new window.Swal({
            icon: 'warning',
            title: t('txt_alert'),
            text: txt,
            confirmButtonText: t('submit')
        });
        } catch (error) {
            console.log(error);
        }
    };
    // end function zone

    function showProfileModal() {
        eventBus.emit('showProfileModal');
    }

    onMounted(() => {
      toggleMode();
      setProfileData();  
    });
</script>
